import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';

// Wistia and Vimeo serve a poster frame from their metadata API, but a video
// given as a direct file url has no such service. Pointing a muted video element
// just past the start makes it paint its own first frame into the tile instead
// (CON-8753).
const PDPVideoPosterFrame = t0 => {
  const $ = _c(3);
  const {
    className,
    src
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== src) {
    t1 = !!src && <video className={className} src={`${src}#t=0.1`} muted={true} playsInline={true} preload="metadata" tabIndex={-1} aria-hidden="true" />;
    $[0] = className;
    $[1] = src;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
PDPVideoPosterFrame.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string
};
export default PDPVideoPosterFrame;